import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

//
import Error404 from '@/views/Error404.vue'
import MembershipCard from '@/views/MembershipCard.vue'
import MyAccount from '@/views/MyAccount.vue'
import Settings from '@/views/Settings.vue'
import Benefits from '@/views/Benefits.vue'
import Memberships from '@/views/Memberships.vue'
import Membership from '@/views/Membership.vue'
import Assignments from '@/views/Assignments.vue'
import Assignment from '@/views/Assignment.vue'
import Volunteer from '@/views/Volunteer.vue'
import Compensations from '@/views/Compensations.vue'
import CompensationForm from '@/views/CompensationForm.vue'
import Pages from '@/views/Pages.vue'
import Page from '@/views/Page.vue'
import Invoices from '@/views/Invoices.vue'
import Invoice from '@/views/Invoice.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'membershipCard',
		component: MembershipCard,
		meta: {
			icon: 'mdi-clipboard-account',
		},
	},

	{
		path: '/benefits',
		name: 'benefits',
		component: Benefits,
		meta: {
			icon: 'mdi-alert-octagram',
		},
	},

	{
		path: '/volunteer',
		name: 'volunteer',
		component: Volunteer,
		meta: {
			icon: 'mdi-hand-heart',
		},
	},

	{
		path: '/myaccount',
		name: 'myAccount',
		component: MyAccount,
		meta: {
			icon: 'mdi-badge-account-horizontal',
			hidden: true,
		},
		children: [
			{
				path: 'memberships',
				name: 'memberships',
				component: Memberships,
				children: [
					{
						path: ':membershipName',
						name: 'membership',
						component: Membership,
						props: true,
					},
				],
			},
			{
				path: 'assignments',
				name: 'assignments',
				component: Assignments,
				children: [
					{
						path: ':assignmentName',
						name: 'assignment',
						component: Assignment,
						props: true,
					},
				],
			},
			{
				path: 'invoices',
				name: 'invoices',
				component: Invoices,
				children: [
					{
						path: ':invoiceId',
						name: 'invoice',
						component: Invoice,
						props: true,
					},
				],
			},
		],
	},

	{
		path: '/compensations',
		name: 'compensations',
		component: Compensations,
		meta: {
			icon: 'mdi-hand-coin',
		},
		children: [
			{
				path: 'form',
				name: 'compensation',
				component: CompensationForm,
				props: true,
			},
		],
	},

	{
		path: '/settings',
		name: 'settings',
		component: Settings,
		meta: {
			icon: 'mdi-cog',
			hidden: true,
		},
	},

	{
		alias: '/materials',
		path: '/:pageName',
		name: 'materials',
		component: Page,
		meta: {
			icon: 'mdi-file-star',
			hidden: true,
		},
		params: {
			pageName: 'materials',
		},
	},

	{
		path: '/pages',
		name: 'pages',
		component: Pages,
		meta: {
			icon: 'mdi-file-document-multiple',
			hidden: true,
		},
		children: [
			{
				path: ':pageName',
				name: 'page',
				component: Page,
				props: true,
			},
		],
	},

	{
		name: 'error404',
		path: '/error404',
		component: Error404,
		meta: {
			hidden: true,
		},
	},

	{
		path: '*',
		redirect: {
			name: 'error404',
		},
		meta: {
			hidden: true,
		},
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
})

// Navigation guards
router.beforeEach((to, from, next) => {
	// If current route is not the first one the user visits,
	// we switch back button to the history mode.
	if (from.name !== null) {
		store.commit('setBackButtonHistoryMode', true)
	}

	// If navigation confirmation is requested, show dialog
	if (store.state.confirmNavigation) {
		store.commit('setConfirmNavigationDialog', true)
		store.commit('setConfirmNavigationRoute', to)
	} else {
		next()
	}
})

export default router
